import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
    (api: MiddlewareAPI) => (next) => (action) => {
        //console.log('rtkQueryErrorLogger')
        // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
        if (isRejectedWithValue(action)) {
            console.warn('We got a rejected action!', action)
            if (action.payload?.status === 401) {

            }
            //Not ready yet
            // toast.error('An unexpected error occurred when calling the Revelation API', {
            //     position: "top-center",
            //     autoClose: 0,
            //     hideProgressBar: true,
            //     closeOnClick: true,
            //     pauseOnHover: false,
            //     draggable: true,
            //     progress: undefined,
            //     theme: "colored",
            //     bodyStyle: {
            //         width: '100%'
            //     }
            //});
        }

        return next(action)
    }